// #region imports

// --- HS Code
import { SurveyResponseTypes } from '../shared/response-types';

// #endregion

export interface InteractiveReportTypeModel {
  type: SurveyResponseTypes;
  title: string;
  key: string;
}
